var _a;
import { MaterialTypeEnum as ServerMaterialType } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { MaterialTypeEnum as ClientMaterialType } from '@features/guidbooks/types/materials/material-type.types';
export var materialTypeMap = createDataRecordConverter((_a = {},
    _a[ClientMaterialType.AcousticTreatmentMaterials] = ServerMaterialType.AcousticTreatmentMaterials,
    _a[ClientMaterialType.MasonryAndSolid] = ServerMaterialType.MasonryAndSolid,
    _a[ClientMaterialType.Frame] = ServerMaterialType.Frame,
    _a[ClientMaterialType.PorousMaterials] = ServerMaterialType.PorousMaterials,
    _a[ClientMaterialType.SandwichPanel] = ServerMaterialType.SandwichPanel,
    _a[ClientMaterialType.GypsumBondedbBoards] = ServerMaterialType.GypsumBondedbBoards,
    _a[ClientMaterialType.WoodBasedBoard] = ServerMaterialType.WoodBasedBoard,
    _a[ClientMaterialType.MineralBondedBoards] = ServerMaterialType.MineralBondedBoards,
    _a[ClientMaterialType.Metal] = ServerMaterialType.Metal,
    _a[ClientMaterialType.Glazing] = ServerMaterialType.Glazing,
    _a[ClientMaterialType.Membrane] = ServerMaterialType.Membrane,
    _a[ClientMaterialType.FoamMaterials] = ServerMaterialType.FoamMaterials,
    _a[ClientMaterialType.AirGap] = ServerMaterialType.AirGap,
    _a[ClientMaterialType.Link] = ServerMaterialType.Link,
    _a[ClientMaterialType.Filler] = ServerMaterialType.Filler,
    _a[ClientMaterialType.Heavy] = ServerMaterialType.Heavy,
    _a[ClientMaterialType.Board] = ServerMaterialType.Board,
    _a[ClientMaterialType.ZPanel] = ServerMaterialType.ZPanel,
    _a));
export var convertToServerMaterialTypeData = function (type) {
    return materialTypeMap.toServer[type];
};
export var convertToClientMaterialTypeData = function (type) {
    return materialTypeMap.toClient[type];
};
